import { render } from "./index.vue?vue&type=template&id=b6972748"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

const cssModules = script.__cssModules = {}
import style0 from "./index.vue?vue&type=style&index=0&id=b6972748&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script